<template>
    <div>
    <cardWrapper>
        <div class="row ">
            <div class="col-md-12 contacts_main">
                <contacts_tpl></contacts_tpl>
            </div>
            <div class="col-md-12">

            </div>
        </div>
        <button class="btn btn-primary mt-2 " @click="$refs.feedback.show()"><font-awesome-icon :icon="['fas', 'envelope']"/> {{$t('message.feedback')}}</button>
    </cardWrapper>
        
        <modal ref="feedback" :footer = false>
            <template v-slot:header>{{ $t("message.feedback") }}</template>
            <template v-slot:body><feedback_form @action_success="$refs.feedback.hide()"></feedback_form></template>

        </modal>
</div>
</template>

<script> 
    import cardWrapper from '@/components/cardWrapper'; 
    import contacts_tpl from '@/components/contacts/contacts_loc'; 
    import feedback_form from '@/forms/feedback_form'; 
    import modal from '@/components/modal'
export default {
  name: 'contacts',
  data () {
   return {
        
   }
  },
  
   components:{
       contacts_tpl,
       cardWrapper,
       feedback_form,
       modal
       
    },
    methods:{
        deleteDevice: function () {   
        }        
    }
    
    
}
</script>
<style>
    .contacts_main  .row .col-sm-9 {
        padding-left:30px; 
    }
    
</style>


